import { Navigate } from 'react-router-dom';

// O formulário de agendamento agora vive dentro de Disparos ("Começar: em uma data").
// Mantemos a rota por compatibilidade com links antigos; ela só redireciona.
export default function Agendamentos() {
  return <Navigate to="/disparo" replace />;
}
